import { render, staticRenderFns } from "./AdminRQQueues.vue?vue&type=template&id=42861030&scoped=true&"
import script from "./AdminRQQueues.vue?vue&type=script&lang=js&"
export * from "./AdminRQQueues.vue?vue&type=script&lang=js&"
import style0 from "./AdminRQQueues.vue?vue&type=style&index=0&id=42861030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42861030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42861030')) {
      api.createRecord('42861030', component.options)
    } else {
      api.reload('42861030', component.options)
    }
    module.hot.accept("./AdminRQQueues.vue?vue&type=template&id=42861030&scoped=true&", function () {
      api.rerender('42861030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminRQQueues.vue"
export default component.exports